import { Reveal } from "./Reveal";
import CashAppLine from "./CashAppLine";
import { MapPin, Phone, Mail, Globe, Droplets } from "lucide-react";
import { scrollToId } from "@/lib/apiClient";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0710] border-t border-white/8 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <Droplets className="w-8 h-8 text-gold mx-auto animate-floaty" strokeWidth={1.3} />
            <p className="font-display text-3xl md:text-4xl text-white mt-6 leading-snug">
              "Therefore, if anyone is in Christ, he is a <span className="italic text-gold">new creation.</span>"
            </p>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#7A708A] mt-4">2 Corinthians 5:17</p>
            <div className="mt-8">
              <CashAppLine testId="cashapp-bottom" />
            </div>
          </div>
        </Reveal>

        <div className="gold-line my-14" />

        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="font-display text-3xl text-white">
              F<span className="text-gold">.</span>O<span className="text-gold">.</span>L<span className="text-gold">.</span>W<span className="text-gold">.</span>A<span className="text-gold">.</span>C<span className="text-gold">.</span>
            </span>
            <p className="text-sm text-[#B4ADC1] font-light mt-4 leading-relaxed">
              Fountain of Living Water Apostolic Church — the world's first totally autonomous agentic A.I. apostolic church.
            </p>
            <p className="text-xs text-[#7A708A] mt-4">Pastor Dr. Hugh Hastings & Mother Dr. Wanda Hastings</p>
          </div>

          <div>
            <p className="section-label">Visit Us</p>
            <div className="mt-5 space-y-3 text-sm text-[#B4ADC1] font-light">
              <a href="https://maps.google.com/?q=411+Fargo+Ave+San+Antonio+TX+78220" target="_blank" rel="noreferrer" className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-address">
                <MapPin className="w-4 h-4 shrink-0 text-gold mt-0.5" /> 411 Fargo Ave, San Antonio, Texas 78220
              </a>
              <p className="flex gap-3"><span className="text-gold font-mono text-xs mt-0.5">SUN</span> Come to the Water · Sunday Worship</p>
            </div>
          </div>

          <div>
            <p className="section-label">Contact</p>
            <div className="mt-5 space-y-3 text-sm text-[#B4ADC1] font-light">
              <a href="tel:+17262475926" className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-phone"><Phone className="w-4 h-4 shrink-0 text-gold" /> 726-247-5926</a>
              <a href="mailto:folwacleadership@gmail.com" className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-email"><Mail className="w-4 h-4 shrink-0 text-gold" /> folwacleadership@gmail.com</a>
              <a href="https://www.folwac.com" target="_blank" rel="noreferrer" className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-web"><Globe className="w-4 h-4 shrink-0 text-gold" /> www.folwac.com</a>
            </div>
          </div>

          <div>
            <p className="section-label">The Ecosystem</p>
            <div className="mt-5 space-y-3 text-sm text-[#B4ADC1] font-light">
              {[["Meet the Ministers", "#ministers"], ["The Living Water Engines", "#engines"], ["Manifesto", "#manifesto"], ["Request Prayer", "#connect"], ["Give", "#give"]].map(([l, h]) => (
                <button key={h} onClick={() => scrollToId(h)} className="block hover:text-gold transition-colors">{l}</button>
              ))}
            </div>
          </div>
        </div>

        <div className="gold-line my-10" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#7A708A] font-mono">
          <p>© {new Date().getFullYear()} Fountain of Living Water Apostolic Church. Redeem · Restore · Revive · Rebuild.</p>
          <a href="/admin" className="hover:text-gold transition-colors" data-testid="footer-admin">Admin · Ministry Portal</a>
        </div>
      </div>
    </footer>
  );
}
